import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowroundtrip(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.571 3.462a.75.75 0 0 1 1.06.015l5.907 6.07A.75.75 0 0 1 21 10.822H3a.75.75 0 0 1 0-1.5h16.224l-4.667-4.798a.75.75 0 0 1 .014-1.06M2.308 13.71A.75.75 0 0 1 3 13.25h18a.75.75 0 0 1 0 1.5H4.79l4.65 4.724a.75.75 0 1 1-1.069 1.052l-5.905-6a.75.75 0 0 1-.158-.816",
    clipRule: "evenodd"
  }));
}
var IcArrowroundtrip = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowroundtrip));

export { IcArrowroundtrip as I };
